import { action } from 'satcheljs';
export var validateDomain = action('validateDomain');
//# sourceMappingURL=validateDomain.js.map